export interface LoginType {
  isUsername: boolean;
  isSms: boolean;
  isEmail: boolean;
  value: string;
}

export function createLoginType(): LoginType {
  return {
    isUsername: false,
    isSms: false,
    isEmail: false,
    value: '',
  };
}
